module.exports = __webpack_public_path__ + "img/letter-envelope.82f26b45.svg";